import createBreakpointReducer from './breakPointReducer';
import debouncer from './debouncer';

// Initial values
let storeRef = null;
let debounceDelay = 100;
let debounce = true;
let dispatchHeight = false;


// Default Resize listener
function onResize() {
    const state = storeRef.getState();
    const previousWidth = state.breakpointReducer.width;
    const currentWidth = window.innerWidth;

    if (currentWidth !== previousWidth || dispatchHeight) {
        storeRef.dispatch({
            type: '@@BREAKPOINT_CHANGE',
            height: dispatchHeight,
            width: currentWidth,
        });
    }
}

function subscribe(callback) {
    let listener = callback;

    if (debounce) {
        listener = debouncer(callback, debounceDelay);
    }

    window.addEventListener('resize', listener);
}

function syncBreakpointWithStore(store, config) {
    storeRef = store;

    if (config) {
        if (config.debounce !== undefined) {
            debounce = config.debounce;
        }

        if (config.debounceDelay !== undefined) {
            debounceDelay = config.debounceDelay;
        }

        if (config.dispatchHeight !== undefined) {
            dispatchHeight = config.dispatchHeight;
        }
    }

    if (typeof window !== 'undefined') {
        subscribe(onResize);

        // Run this in the next tick so hydration can start with the server snapshot.
        setTimeout(() => {
            storeRef.dispatch({
                type: '@@BREAKPOINT_CHANGE',
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }, 0);
    }
}


export default syncBreakpointWithStore;
export { createBreakpointReducer };
